// import jwtDecode from 'jwt-decode';
import { verify, sign } from 'jsonwebtoken';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  return true;
};


const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('commonAccessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('commonAccessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

const setUserType = (userType) => {
  if (userType) {
    localStorage.setItem('commonUserType', userType);
  } else {
    localStorage.removeItem('commonUserType');
  }
}


export { isValidToken, setSession, verify, sign, setUserType };
